import React, { useEffect } from 'react';

const sizeClassMap = {
    sm: 'max-w-md',
    md: 'max-w-lg',
    lg: 'max-w-3xl',
    xl: 'max-w-5xl',
    full: 'max-w-[95vw]'
};

const Modal = ({ isOpen, onClose, children, size = 'md', className = '', hideCloseButton = false }) => {
    const open = typeof isOpen === 'undefined' ? true : !!isOpen;

    useEffect(() => {
        if (!isOpen) return;
        const handleKeyDown = (e) => {
            if (e.key === 'Escape') onClose();
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [open, onClose]);

    if (!open) return null;

    const maxWidthClass = sizeClassMap[size] || sizeClassMap.md;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40" onClick={onClose}>
            <div
                className={`bg-white rounded-lg shadow-lg ${maxWidthClass} w-full p-6 relative ${className}`}
                onClick={e => e.stopPropagation()}
            >
                {!hideCloseButton && (
                    <button
                        className="absolute top-2 right-2 text-gray-400 hover:text-gray-600 text-2xl font-bold focus:outline-none"
                        onClick={onClose}
                        aria-label="Close"
                    >
                        &times;
                    </button>
                )}
                {children}
            </div>
        </div>
    );
};

export default Modal; 